var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3335 11.6668H21.6668V15.0002H18.3335V11.6668ZM18.3335 18.3335H21.6668V28.3335H18.3335V18.3335ZM20.0002 3.3335C10.8002 3.3335 3.3335 10.8002 3.3335 20.0002C3.3335 29.2002 10.8002 36.6668 20.0002 36.6668C29.2002 36.6668 36.6668 29.2002 36.6668 20.0002C36.6668 10.8002 29.2002 3.3335 20.0002 3.3335ZM20.0002 33.3335C12.6502 33.3335 6.66683 27.3502 6.66683 20.0002C6.66683 12.6502 12.6502 6.66683 20.0002 6.66683C27.3502 6.66683 33.3335 12.6502 33.3335 20.0002C33.3335 27.3502 27.3502 33.3335 20.0002 33.3335Z",
    fill: "#647B8F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.81ab7304.svg";
export { ForwardRef as ReactComponent };